// **********************************************************************
// ******** Profissionais e Serviços oferecidos pelo Prestador *********
// ******** app/PrestadorProfile/profissionaisservicos.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 15/07/24 | 19h24
// ******** modificação: 22/8/24 | 14h59
// ******** modificação: 24/10/24w | 23h18 | eliminamos poluição visual
// ******** modificação: 28/10/24w | 12h18 | exibição da foto do "colaborador" junto com seu nome
// ******** modificação: 12/11/24w | 14h38 | acrescentamos a variável "intervaloAtendimento" que vem do "prestadorprofile.jsx"
// ******** modificação: 27/12/24w | 14h38 | acrescentamos a foto do serviço marcado pelo colaborador
// ******** Profissionais e Serviços oferecidos pelo Prestador *********
// **********************************************************************




import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import apiaxios from '../../../../Services/apiaxios';
import Swal from 'sweetalert2';
import { Oval } from 'react-loader-spinner';
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Icon from '@mdi/react';
import { mdiArrowLeftCircle } from '@mdi/js';
import Footer from '../../components/Footer/footer';
import './profissionaiseservicos.css';

function ProfissionaisServicos() {
    const { state } = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id } = useParams();
    const [profissionais, setProfissionais] = useState([]);
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPrestador || null);
    const [nomeEmpresa, setNomeEmpresa] = useState(state?.nomePrestador || null);
    const [enderecoEmpresa, setEnderecoEmpresa] = useState(state?.enderecoPrestador || null);
    const [celularEmpresa, setCelularEmpresa] = useState(state?.celularPrestador || null);
    const [intervaloAtendimento, setIntervaloAtendimento] = useState(state?.intervaloAtendimento || 60);
    const [servicos, setServicos] = useState([]);
    const [selectedProfissional, setSelectedProfissional] = useState(null);
    const [loading, setLoading] = useState(false); // estava como true 27/12/24w
    const [loadingFotoColaborador, setLoadingFotoColaborador] = useState(false);
    const [error, setError] = useState(null);
    const [profissionalNome, setProfissionalNome] = useState(null);
    const navigate = useNavigate();
    const servicosRef = useRef(null);  // Ref para a seção de serviços

    // verifica se é mobile, tablet, nb, pc, etc
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // monitora e carrega a lista de profissionais/colaboradores, toda vez q mudar
    useEffect(() => {
        fetchProfissionais();
    }, [id]);

    // carrega a lista de profissionais/colaboradores
    const fetchProfissionais = async () => {
        setLoading(true);
        try {
            // alert('fetchProfissionais');
            const response = await apiaxios.get(`/empresaLink/colaboradoresWeb`, {
                params: { id_empresa: id }
            });
            
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setProfissionais(response.data);
                    fetchColaboradoresFoto(response.data);
                } else {
                    setError('Nenhum colaborador encontrado.');
                }
            } else {
                const errorMessage = response.data.retorno || 'Erro desconhecido';
                setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.retorno || 'Erro desconhecido';
                setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            } else {
                setError('Erro ao carregar colaboradores.');
                Swal.fire('Erro', 'Erro ao carregar colaboradores.', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    // carrega na sequência a foto de cada colaborador/profissional
    const fetchColaboradoresFoto = async (colaboradoresFotos) => {
        const promises = colaboradoresFotos.map(async (profissional, index) => {
            try {
                const fotoResponse = await apiaxios.get(`/colaborador/FotoPerfilWeb?id_colaborador=${profissional.COL_ID}`);
                // console.log('foto colaborador ', fotoResponse.data.foto);
                // console.log('data colaborador ', fotoResponse.data);
                if (fotoResponse.data.retorno === "OK" && fotoResponse.data.foto) {
                    profissional.COL_FOTO = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
                }
            } catch (error) {
                // handleApiError(error); // função inexistente nesta página 28/10/24w
                console.error(error);
            } finally {
                // Update the state with the new data including the photo
                setProfissionais(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = profissional;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };

    // carrega os serviços do profissional clicado
    const handleProfissionalClick = async (profissionalId, profissionalNome) => {
        setLoading(true);
        setSelectedProfissional(profissionalId);
        setProfissionalNome(profissionalNome); // guardar o nome do profissional para a próxima tela
        // console.log("profissionalId: ", profissionalId);
        try {
            // const response = await apiaxios.get(`/empresa/colaboradorServicoWeb`, {
            const response = await apiaxios.get(`/colaborador/ServicoWebLink`, {
                params: { id_colaborador: profissionalId }
            });

            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setServicos(response.data);
                    fetchServicosFoto(response.data);
                    // console.log('response.data: ', response.data);
                    // servicosRef.current.scrollIntoView({ behavior: 'smooth' });  // Scroll para a seção de serviços
                    // Aguardar um ciclo de renderização antes de rolar
                    setTimeout(() => {
                        if (servicosRef.current) {
                            servicosRef.current.scrollIntoView({ behavior: 'smooth' });
                        }
                    }, 100); // Atraso pequeno para garantir que a renderização ocorreu
                } else {
                    setError('Nenhum serviço encontrado para este colaborador.');
                }
            } else {
                const errorMessage = response.data.retorno || 'Erro desconhecido';
                // setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            }
        } catch (error) {
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.retorno || 'Erro desconhecido';
                // setError(errorMessage);
                // alert('catch');
                Swal.fire('Erro', errorMessage, 'error');
            } else {
                // setError('Erro ao carregar serviço(s) do Colaborador selecionado.');
                Swal.fire('Erro', 'Erro ao carregar serviço(s) do Colaborador selecionado.', 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    // carrega na sequência a foto de todos os serviços
    const fetchServicosFoto = async (servicosFotos) => {
        // console.log('fetchServicosFoto ', servicosFotos);
        const promises = servicosFotos.map(async (servico, index) => {
            try {
                const fotoResponse = await apiaxios.get(`/servico/FotoServicoWeb?id_usuario=${id}&id_servico=${servico.SER_ID}`);
                // console.log('data foto serviço ', fotoResponse.data.foto);
                // console.log('data serviço: ', fotoResponse.data);
                if (fotoResponse.data.retorno === "OK" && fotoResponse.data.foto) {
                    // console.log('data retorno ok: ', fotoResponse.data.retorno);
                servico.SER_FOTO = `data:image/jpeg;base64,${fotoResponse.data.foto}`;
                }
            } catch (error) {
                // handleApiError(error); // função inexistente nesta página 28/10/24w
                console.error(error);
            } finally {
                // Update the state with the new data including the photo
                setServicos(prevDados => {
                    const newDados = [...prevDados];
                    newDados[index] = servico;
                    return newDados;
                });
            }
        });
        return Promise.all(promises);
    };

    // abre a agenda de horários, após serviço escolhido do coloborador previamente escolhido
    const handleServicoClick = (servicoId, servicoNome, servicoValor) => {
        // console.log('profissional: ', profissionalNome, 'serviço: ', servicoNome);
        navigate(`/agendar/${linkpersonalizado}/${id}/profissional/${selectedProfissional}/servico/${servicoId}/agendamento` , { 
            state: { 
                nomeEmpresa, 
                enderecoEmpresa, 
                celularEmpresa,
                fotoPerfil, 
                profissionalNome, 
                servicoNome, 
                servicoValor, 
                intervaloAtendimento // repassa o tempo de agendamento para a próxima página
            } 
        });
    };

    //volta uma página anterior
    const handleBackClick = () => {
        navigate(-1); // Navegar para a página anterior
    };

    // if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;

    const formatCurrency = (value) => {
        // console.log('formatCurrency :', value);
        if (value === undefined || value === null || value === 0) {
            // return 'R$ 0,00';
            // console.log('dentro undefined ou null', value);
            return 'Valor a combinar';
        } else {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    };




    return (
        <div>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col py-3 me-3 text-center">
                        <button className="btn btn-secondary back-button position-fixed top-0 start-0 m-3" onClick={handleBackClick}>
                            <Icon path={mdiArrowLeftCircle} size={1}/> {!isMobile && 'Voltar'}
                        </button>
                        <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                        <br/>

                        {loading && (
                        <div className="loading-spinner-container">
                            <Oval color="#00BFFF" height={80} width={80} />
                        </div>
                        )}
                            {fotoPerfil ? (
                                <div className='text-center'>
                                    <img src={fotoPerfil} alt={nomeEmpresa} className='usuario-foto'/>
                                </div>
                            ) : (
                                <p>{nomeEmpresa}</p>                                        
                            )}

                        <div className="box-colaboradores">
                            <h1>Com quem você quer ser atendido?</h1>
                            <br />
                            <ul>
                                <div className="d-grid gap-2">
                                    {/* {profissionais} */}
                                    {profissionais.map(profissional => (
                                        <li 
                                            className={`btn btn-success m-10 p-20 ${selectedProfissional === profissional.COL_ID ? 'selected' : ''}`} 
                                            key={profissional.COL_ID} 
                                            onClick={() => handleProfissionalClick(profissional.COL_ID, profissional.COL_NOME)}
                                        >
                                            <div className="text-center">
                                                {profissional.COL_FOTO ? (
                                                        <img src={profissional.COL_FOTO} alt='' height="84" width="56" className='usuario-foto'/>
                                                    ) : (
                                                        ''
                                                )}
                                                {/* <img src={profissional.COL_FOTO || imgLogoMini} alt='' height="84" width="56" className='usuario-foto'/> */}
                                                <h3>{profissional.COL_NOME}</h3>
                                                {profissional.COL_ESPECIALIDADE}
                                            </div>
                                        </li>
                                    ))}
                                </div>
                            </ul>
                        </div>
                        <br />
                        <h5>Escolha o serviço e clique no botão "Agendar"</h5>
                        {selectedProfissional && (
                            <div ref={servicosRef} className="box-colaboradores">
                                <table>
                                    <thead>
                                        <tr>
                                            {/* foto ↓*/}
                                            <th></th>
                                            {/* descrição ↓*/}
                                            <th></th>
                                            {/* vr total ↓ */}
                                            <th></th>
                                            {/* botão agendar ↓ */}
                                            <th className="text-right"></th>
                                        </tr>
                                    </thead>  
                                    <tbody>
                                        {/* {* <div className={`${isMobile ? 'text-center' : ''}`}> */}
                                        {servicos.map((servicos) => (
                                            <tr key={servicos.SER_ID}>
                                                <td data-label="">
                                                    {servicos.SER_FOTO ? (
                                                            // <img src={servicos.SER_FOTO} alt='' height="84" width="56" className='cardservico-foto'/>
                                                            <img src={servicos.SER_FOTO} alt='' className='profissional-servico-foto'/>
                                                        ) : (
                                                            ''
                                                    )}
                                                </td>
                                                <td className="text-left fs-5" data-label="">{servicos.SER_DESCRICAO}</td>
                                                {/* <td className="text-left"data-label="">
                                                {console.log('servicos map ', servicos.SER_VALORTOTAL)}
                                                {console.log('servicos id ', servicos.SER_ID)}
                                                {servicos.SER_VALORTOTAL === 0 ? (
                                                        'VR A COMBINAR'
                                                    ) : (
                                                        formatCurrency(servicos.SER_VALORTOTAL)
                                                    )}
                                                {console.log('servicos map ', servicos.SER_VALORTOTAL)}
                                                </td> */}
                                                <td className="text-left"data-label="">
                                                    {formatCurrency(servicos.SER_VALORTOTAL)}
                                                </td>
                                                <td className="text-right">
                                                    <button
                                                        onClick={() => handleServicoClick(servicos.SER_ID, servicos.SER_DESCRICAO, formatCurrency(servicos.SER_VALORTOTAL))}
                                                        className="btn btn-success ml-10"
                                                    >
                                                        <i className="bi bi-clock-history"></i> Agendar
                                                    </button>
                                                </td>
                                            </tr>
                                            ))}
                                        {/* * </div> * */}
                                    </tbody>
                                    {/* <tbody className={isMobile ? "mobile-table text-center" : "text-center"}>
                                        {servicos.map((servico, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <img
                                                        src={servico.SER_FOTO || imgLogoMini}
                                                        alt={servico.SER_NOME}
                                                        className="img-thumbnail servico-foto"
                                                    />
                                                </td>
                                                <td>
                                                    <div className="servico-descricao">
                                                        <strong>{servico.SER_NOME}</strong>
                                                        <p>{servico.SER_DESCRICAO}</p>
                                                        <p><strong>R$ {servico.SER_VALOR}</strong></p>
                                                        <button
                                                            className="btn btn-success ml-10 btn-agendar"
                                                            onClick={() => handleServicoClick(servico)}
                                                        >
                                                            <i className="bi bi-clock-history"></i> Agendar
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody> */}
                                </table>
                            </div>
                        )}
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProfissionaisServicos;